import { FC, memo } from 'react';

import CompanyPresenter from './CompanyPresenter';

const Company: FC = memo(() => (
  <CompanyPresenter />
));

export default Company;
